import React, { useEffect, useRef, useState } from "react";
import SelectBox1 from "../../../components/SelectBox1";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import { toast } from "react-toastify";
import {
  edit_icon,
  toggle_off,
  toggle_on,
  view_icon,
} from "../../../assets/imgs";
import { Table } from "../../../components/Table/Table";
import useSearch from "../../../components/Searchbox/useSearch";
import { useLocation } from "react-router-dom";

const AlertTypesAndCameraNew = ({
  alertData,
  data,
  editable,
  selected,
  list,
  setList,
}) => {
  console.log("alertDatas--->", alertData);

  let [siteAlert, setSiteAlert] = useState([]);

  console.log("editable====>", editable);

  let filteredData = alertData.filter((i) => selected?.includes(i.id)) || [];

  console.log("filteredData--->", filteredData);

  const [form, setForm] = useState([
    {
      id: 1,
      cameraName: "",
      cameraId: "",
      selectedAlerts: [],
      alertTypes: filteredData?.map((i) => ({
        label: i?.name ?? i?.alert_type,
        value: i?.id,
      })),
      errors: {},
    },
  ]);

  const [page, setPage] = useState(1);
  const [edit, setEdit] = useState(null);
  const [search, setSearch] = useState("");
  const [alert, setAlert] = useState(null);
  const searchVal = useSearch(search);
  const isEditMode = edit !== null;
  const focusRef = useRef(null);
  const countRef = useRef(0);

  useEffect(() => {
    if (data) {
      fetchData(data, searchVal, alert);
      // Reset form when site changes
      setForm([
        {
          id: 1,
          cameraName: "",
          cameraId: "",
          selectedAlerts: [],
          alertTypes: filteredData?.map((i) => ({
            label: i?.name ?? i?.alert_type,
            value: i?.id,
          })),
          errors: {},
        },
      ]);
      setEdit(null);
    }
  }, [data]);

  useEffect(() => {
    setForm((prev) =>
      prev.map((item) => ({
        ...item,
        alertTypes: filteredData.map((i) => ({
          label: i?.name ?? i?.alert_type,
          value: i?.id,
        })),
        selectedAlerts: item.selectedAlerts.filter((sel) =>
          filteredData.some((f) => f.id === sel.value),
        ),
      })),
    );
  }, [selected, alertData]);

  //Form Functions

  const handleChange = (e, id, name) => {
    let val = e.target.value;
    setForm((prev) =>
      prev.map((i) =>
        i.id == id
          ? { ...i, [name]: val, errors: { ...i.errors, [name]: "" } }
          : i,
      ),
    );
  };

  const handleAlertChange = (value, id) => {
    setForm((prev) =>
      prev.map((i) =>
        i.id === id
          ? {
              ...i,
              selectedAlerts: value,
              errors: { ...i.errors, selectedAlerts: "" },
            }
          : i,
      ),
    );
  };

  const validateRow = (row) => {
    const errors = {};

    if (!row.cameraName.trim()) {
      errors.cameraName = "Camera name is required";
    }

    if (!row.cameraId.trim()) {
      errors.cameraId = "Camera id is required";
    }

    return errors;
  };

  console.log("listAlert", list);

  const handleAdd = async (i) => {
    const errors = validateRow(i);

    if (Object.keys(errors).length > 0) {
      setForm((prev) =>
        prev.map((item) => (item.id === i.id ? { ...item, errors } : item)),
      );
      return;
    }

    let formData = new FormData();
    formData.append("knf_company_site_id", data);
    formData.append("name", i?.cameraName);
    formData.append("code", i?.cameraId);

    i?.selectedAlerts?.forEach((item, ind) => {
      formData.append(`alert_type_ids[${ind}]`, item?.value);
    });

    let updateFormData = new FormData();
    i?.selectedAlerts?.forEach((item, ind) => {
      updateFormData.append(`alert_type_ids[${ind}]`, item?.value);
    });
    updateFormData.append("knf_company_site_id", data);
    updateFormData.append("name", i?.cameraName);
    updateFormData.append("code", i?.cameraId);
    updateFormData.append("camera_id", edit);

    let URLS = edit ? URL.SITE_CAMERA_ALERT_UPDATE : URL.SITE_CAMERA_ALERT_ADD;
    let payload = edit ? updateFormData : formData;

    for (let val of payload) {
      console.log(val[0], val[1]);
    }

    let res = await post(URLS, payload);
    if (res?.status == "success") {
      toast.success(res?.message);
      if (edit) {
        setForm([
          {
            id: 1,
            cameraName: "",
            cameraId: "",
            selectedAlerts: [],
            alertTypes: filteredData.map((i) => ({
              label: i?.name ?? i?.alert_type,
              value: i?.id,
            })),
            errors: {},
          },
        ]);
        setEdit(null);
      } else {
        let newObj = {
          id: i.id + 1,
          cameraName: "",
          cameraId: "",
          selectedAlerts: [],
          alertTypes: filteredData.map((i) => ({
            label: i?.name ?? i?.alert_type,
            value: i?.id,
          })),
          errors: {},
        };

        setForm((prev) => [...prev, newObj]);
      }
      fetchData(data);
    }
  };

  const handleRemove = (id) => {
    let filterForm = form.filter((i) => i.id !== id);
    setForm(filterForm);
  };

  //Table Functions

  const fetchData = async (id, search = "", alert = {}) => {
    let payload = {
      knf_company_site_id: id,
      search: search ?? "",
      alert_type_ids: alert?.value ? [alert?.value] : [],
    };
    let res = await post(URL.SITE_CAMERA_ALERT_LIST, payload);
    if (res?.status == "success") {
      console.log("response-->", res);
      setList(res?.data);
      countRef.current = res?.data?.length;
    }
  };

  const handleStatus = async (i) => {
    let payload = {
      camera_id: i?.id,
      status: i?.status === 1 ? 0 : 1,
    };

    let res = await post(URL.SITE_CAMERA_ALERT_STATUS, payload);

    if (res?.status == "success") {
      toast.success(res?.message);
      fetchData(data);
    } else {
      toast.error(res?.message);
    }
  };

  const handleEdit = (i) => {
    setEdit(i?.id);
    const selectedAlerts =
      i?.alert_types?.map((val) => ({
        label: val?.name,
        value: val?.id,
      })) || [];

    setForm([
      {
        id: 1,
        cameraName: i?.name || "",
        cameraId: i?.code || "",
        selectedAlerts,
        alertTypes: filteredData.map((a) => ({
          label: a?.name ?? a?.alert_type,
          value: a?.id,
        })),
        errors: {},
      },
    ]);
  };

  useEffect(() => {
    if (data) {
      fetchData(data, searchVal, alert);
    }
  }, [searchVal, alert]);

  useEffect(() => {
    if (edit && focusRef.current) {
      requestAnimationFrame(() => {
        focusRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        focusRef.current.focus();
      });
    }
  }, [edit]);

  const { pathname } = useLocation();

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{row.index + 1}</p>;
        },
      },
      {
        Header: "Camera Name",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p>{value ?? "-"}</p>;
        },
      },
      {
        Header: "Camera Code",
        accessor: "code",
        Cell: ({ value, row }) => {
          return <p>{value ?? "-"}</p>;
        },
      },
      {
        Header: "Alert Types",
        accessor: "alert_types",
        Cell: ({ value }) => {
          if (!value || value.length === 0) {
            return <p>NO Alerts</p>;
          }

          return (
            <>
              {value.map((i, idx) => (
                <p key={i?.id ?? idx}>{i?.name ?? "-"}</p>
              ))}
            </>
          );
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                className={`border-0 ms-2 cust-btn `}
                onClick={() => handleStatus(row?.original)}
                disabled={pathname == "/alert-types-camera"}
              >
                {value == 1 ? (
                  <img className="toggle-btn" src={toggle_on} />
                ) : (
                  <img className="toggle-btn" src={toggle_off} />
                )}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc">
                <button
                  className="cust-btn"
                  onClick={() => handleEdit(row?.original)}
                  disabled={pathname == "/alert-types-camera"}
                >
                  <img src={edit_icon} alt="" className="mx-2 edit-btn " />
                </button>
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [],
  );

  console.log("alert", alert);
  console.log("form", form);

  return (
    <div className="col-md-12">
      {pathname !== "/alert-types-camera" && (
        <>
          <hr className="my-4" style={{ border: "1px solid #852e59" }} />

          {form.map((i) => {
            console.log("i", i);
            return (
              <div
                key={edit ? `edit-${edit}` : i.id}
                className="d-flex ac-js mb-3"
                ref={edit ? focusRef : null}
                tabIndex={-1}
              >
                <div className="col-md-1">
                  <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17  ">
                    S.No
                  </p>
                  <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-2 mt-3 ms-3">
                    {i.id}
                  </p>
                </div>
                <div className="col-md-3">
                  <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 ">
                    Camera Name
                  </p>
                  <input
                    type="text"
                    value={i.cameraName}
                    onChange={(e) => handleChange(e, i.id, "cameraName")}
                    placeholder="Enter camera name"
                    className="input-box w-70"
                    disabled={i.id != form.length}
                  />
                  {i.errors.cameraName && (
                    <p className="err">{i.errors.cameraName}</p>
                  )}
                </div>
                <div className="col-md-3">
                  <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 ">
                    Camera ID
                  </p>
                  <input
                    type="text"
                    value={i.cameraId}
                    onChange={(e) => handleChange(e, i.id, "cameraId")}
                    placeholder="Enter Camera ID"
                    className="input-box w-70"
                    disabled={i.id != form.length}
                  />
                  {i.errors.cameraId && (
                    <p className="err">{i.errors.cameraId}</p>
                  )}
                </div>
                <div className="col-md-4">
                  <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 ">
                    Alert Types
                  </p>
                  <SelectBox1
                    options={i.alertTypes}
                    selected={i.selectedAlerts}
                    setSelected={(val) => handleAlertChange(val, i.id)}
                    isMulti={true}
                    isDisabled={i.id != form.length}
                    placeholder={"Select Alert type"}
                  />
                </div>
                {i.id == form.length && (
                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 ms-4">
                      Actions
                    </p>
                    <div className="d-flex ac-jc">
                      <button
                        className="small-btn ms-4 d-flex align-items-center justify-content-center gap-2 "
                        onClick={() => handleAdd(i)}
                      >
                        <CheckCircleIcon fontSize="small" />
                      </button>
                      {i.id !== 1 && (
                        <button
                          className="small-btn ms-4 d-flex align-items-center justify-content-center gap-2"
                          onClick={() => handleRemove(i.id)}
                        >
                          <CancelIcon />
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
          <hr className="my-4" style={{ border: "1px solid #852e59" }} />
        </>
      )}

      <div className="d-flex ac-jb mt-2 w-100">
        <h4 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22  mb-0 ">
          Total Count : {countRef.current}
        </h4>
        <div className="col-md-4">
          <SelectBox1
            options={filteredData.map((i) => ({
              label: i?.name ?? i?.alert_type,
              value: i?.id,
            }))}
            selected={alert}
            setSelected={(val) => setAlert(val)}
            placeholder={"Select Alert type"}
          />
        </div>
        <div className="d-flex ac-jc">
          <h4 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22  me-3 mb-0 ms-3">
            Search
          </h4>
          <input
            type="text"
            className="input-pop ps-2"
            placeholder=" Search"
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </div>
      </div>
      <Table
        data={list ?? []}
        columns={columns}
        show={true}
        pageno={page}
        setPageno={setPage}
      />
    </div>
  );
};

export default AlertTypesAndCameraNew;
